<template>
  <div>
    <div v-if="stravaRetry">
      <Header />

      <div class="Auth">
        <div class="Auth__image"></div>
        <div class="Auth__form">
          <div class="w-full">
            <h1 class="md:text-4xl mb-3 text-3xl font-extrabold leading-tight">Allow FormBeat to connect to your Strava</h1>
            <p class="mb-6 text-lg">
              You're signed in to Strava, but the authorization didn't finish. Click below to allow FormBeat to connect to your Strava account.
            </p>

            <img src="~images/connect-with-strava.svg" alt="Connect with Strava" class="mb-3 -ml-1 cursor-pointer" width="256" @click="connectStrava()" />
          </div>
        </div>
      </div>

      <Footer />
    </div>
    <div v-else-if="error">
      {{ error }}
    </div>
    <LoadingIcon v-else />
  </div>
</template>

<script>
import AnalyticsService from 'services/AnalyticsService'
import GarminService from 'services/GarminService'
import StravaService from 'services/StravaService'

import Header from 'components/Header'
import Footer from 'components/Footer'

export default {
  components: {
    Header,
    Footer
  },

  data() {
    return {
      error: null,
      stravaRetry: false
    }
  },

  async mounted() {
    try {
      // Handle Strava authorization
      if (this.$route.name === 'oauth.success.strava') {
        // Strava sometimes redirects back without a code after an in-flow login
        // (e.g. email one-time code in Safari) — offer to restart the authorization
        if (!this.$route.query.code) {
          this.stravaRetry = true
          this.$posthog?.capture('strava_oauth_missing_code', { source: 'web' })
          return
        }

        const user = await StravaService.authorize(this.$route.query.code, this.$route.query.scope)

        if (user && user.new_signup) {
          try {
            if (user.email) {
              AnalyticsService.trackSignupConversion(user.email)
            } else {
              AnalyticsService.deferSignupConversion()
            }
          } catch (e) {
            // noop
          }
        }
      }

      // Handle Garmin authorization
      if (this.$route.name === 'oauth.success.garmin') {
        const user = await GarminService.authorize(this.$route.query.oauth_verifier)

        if (user && user.new_signup) {
          try {
            if (user.email) {
              AnalyticsService.trackSignupConversion(user.email)
            } else {
              AnalyticsService.deferSignupConversion()
            }
          } catch (e) {
            // noop
          }
        }
      }

      // Redirect to dashbobard
      const { href } = this.$router.resolve({ name: 'dashboard' })
      window.location = window.location.origin + href
    } catch (e) {
      this.error = 'Oops, something wrong happened.'
    }
  },

  methods: {
    async connectStrava() {
      StravaService.connect(true)
      AnalyticsService.trackEvent('conversion', 'connect-with-strava')
      AnalyticsService.ahoyTrackEvent('connect-with-strava')
    }
  }
}
</script>
